export default __webpack_public_path__ + "static/featured_properties2-cd5de6d782aaac4ce992ab45a6ae7353.png";